import React, {Component} from 'react'
import {connect} from 'react-redux'

class AdditionalContextButton extends Component {
    openFichePatrimoine = () => {
        this.contextWindow && this.contextWindow.close()
        this.contextWindow = window.open('/static/fichePatrimoine.html', '', 'location=no')
    }

    /**
     *
     * @param event return by connect
     *        contains context & event for display additional info
     *        can be null but always authenticated: user.authenticated setted
     */
    componentWillReceiveProps(event) {
        const {patrimonyUid, context, eventType} = event

        if (this.props.patrimonyUid !== patrimonyUid && this.contextWindow) {
            this.contextWindow.postMessage({patrimonyUid, context, eventType})
        }
    }

    isAuthorized = () => {
        const {authenticated} = this.props
        return ['callCenterOperator', 'callCenterUser'].indexOf(authenticated.userType) !== -1
    }

    render () {
        return this.isAuthorized() && <button onClick={this.openFichePatrimoine}>Fiche Contextuelle</button>
    }
}

const ticketShowedFromDetailedTicketCtx = (ticket, router) => {
    const detailedTicket = ticket.ticket

    const {location} = router || {}
    const {pathname} = location || {}
    const isTicketDetail = detailedTicket && (pathname === `/tickets/${detailedTicket.uid}`)

    return (detailedTicket && isTicketDetail && detailedTicket.linkedEntities.patrimony && {
        patrimonyUid: detailedTicket.linkedEntities.patrimony.uid,
        context: 'DetailedTicket',
        eventType: 'TicketShowed'
    })
}

const patrimonySelectedFromOpenTicketCtx = (ticket, ui) => {
    const {openTicketCmd} = ticket
    const {locationRef} = openTicketCmd || {}
    const {patrimonyUid} = locationRef || {}
    const {uid} = patrimonyUid || {}

    const hasModalOpened = ui && ui['Ticket/OpenTicketModal'] && ui['Ticket/OpenTicketModal'].opened

    return (uid && hasModalOpened && {
        patrimonyUid: uid,
        context: 'OpenTicket',
        eventType: 'PatrimonySelected'
    })
}

export default connect(
    function ({ticket, user, ui, router}) {
        const result = patrimonySelectedFromOpenTicketCtx(ticket, ui) || ticketShowedFromDetailedTicketCtx(ticket, router)

        return {...result, authenticated: user.authenticated}
    }
)
(AdditionalContextButton)


// WEBPACK FOOTER //
// ./lib/app/components/AdditionalContextButton.js